export const MESSAGES = {
  AUTH: {
    SUCCESS: {
      LOG_OUT: 'Successfully logged out',
    },
    WARNING: {
      RETRY_LOGIN: 'Please retry login',
    },
    ERROR: {
      ACCOUNT_NOT_FOUND: 'Account does not exist',
      USER_NOT_FOUND: 'User does not exist',
      INVALID_TOKEN: 'Access denied: Invalid Token',
      NOT_LOGGED_IN: 'You are not logged in.',
      INVALID_DEVICE_ID: 'Access denied: Invalid Device ID',
    },
  },
  CONTAINERS: {
    SUCCESS: {
      FILES_CHANGE: 'Changes made!',
      CREATE: 'Created',
      CREATE_WITH_IMAGES: 'Created with images',
      SET_LOCATION: 'Location set successfully',
    },
    ERROR: {
      FILES_CHANGE: 'Changes not made!',
      DUPLICATED:
        'Unable to create Gate In requests: Active Gate In requests with the same container numbers in the Yard',
      SET_LOCATION: 'Location not set',
    },
  },
  GATE_IN: {
    ERROR: {
      NOT_COMPLETED: 'Gate in not completed',
      NOT_ADDED: 'Gate in not added',
    },
  },
  GATE_OUT: {
    SUCCESS: {
      COMPLETED: 'Gate out successfully completed',
      LOADED: 'Gate out successfully loaded',
      CREATED_FROM_FILTER: 'Gate out successfully created from filter',
    },
    ERROR: {
      NOT_COMPLETED: 'Gate out not completed',
      NOT_LOADED: 'Gate out not loaded',
      NOT_CREATED_FROM_FILTER: 'Gate out not created from filter',
    },
  },
  INVENTORY: {
    SUCCESS: {
      COMPLETED: 'Inventory successfully completed',
      CHECKED: 'Inventory successfully checked',
    },
    ERROR: {
      CHECKED: 'Inventory not checked',
    },
    WARNING: {
      NOT_FOUND: 'Container not found',
    },
  },
  REPAIR: {
    SUCCESS: {
      CREATED: 'Repair successfully created',
      UPDATED: 'Repair successfully updated',
      COMPLETED: 'Repair successfully completed',
      DELETED: 'Repair successfully deleted',
    },
    ERROR: {
      NOT_SET: 'Repair not created',
      NOT_COMPLETED: 'Repair not completed',
      NOT_DELETED: 'Repair not deleted',
      NOT_UPDATED: 'Repair not updated',
    },
  },
  YARD: {
    SUCCESS: {
      SEND_CONTRACT:
        'You do not have a contract with this Yard yet. Our team will contact you within 24 hours.',
    },
  },
  OCR: {
    SERVER_OFF: 'Server is off',
    NOT_FOUND: 'Text not found',
  },
  CONSTRUCTION: {
    HEADING: 'We will be back',
  },
  ERROR_BOUNDARY: {
    HEADING: 'Something went wrong',
    DEFAULT: 'Something went wrong',
    DETAIL: 'Probably, it is not your fault. Please come back later!',
  },
  NETWORK: {
    ERROR: 'Network error',
    ALREADY_EXISTS: 'Already exists',
    WARNING: {
      TRY_AGAIN: 'Please try again',
      WIFI_ERROR:
        'Please restart your Wi-Fi, then refresh the page. There appears to be a Wi-Fi error',
    },
  },
};

export const INPUT_ERRORS = {
  REQUIRED: {
    BLOCK: 'Block is required',
    ROW: 'Row is required',
    SLOT: 'Slot is required',
    TIER: 'Tier is required',
    YARD_NAME: 'Yard Name is required',
    DATE: 'Date is required',
    CLIENT_NAME: 'Client Name is required',
    CONTAINER_NUMBER: 'Container Number is required',
    CONTAINER_TYPE: 'Container Type is required',
    CONTAINER_CONTENT: 'Container Content is required',
    LICENSE_PLATE_NUMBER: 'License Plate Number is required',
    DRIVER_NAME: 'Driver Name is required',
    IMAGES: 'Images is required',
    PRICE: 'Price is required',
    DAYS_TO_COMPLETE: 'Days To Complete is required',
    DESCRIPTION: 'Description is required',
  },
  NOT_VALID: {
    EMAIL: 'Email is not valid',
    CONTAINER_NUMBER: 'Container Number is not valid',
    CONTAINER_NUMBER_SHORT: 'Not valid number',
    CONTAINER_NUMBER_MIN: 'Min 3 characters',
    COMMENT_LENGTH: 'Comment must have between 10 and 200 characters',
    DRIVER_NAME: 'Driver Name is not valid',
    USERNAME_LENGTH: 'User Name must have between 1 and 30 characters',
    LICENSE_PLATE_NUMBER: 'License Plate Number is not valid',
    LICENSE_PLATE_NUMBER_LENGTH: 'License Plate must have between 4 and 10 characters',
    DATE: 'Date is not valid',
    PHONE_NUMBER: 'Phone Number is not valid',
    MAX_UPLOAD_FILES: 'Max Upload Files is 10',
    PRICE_MIN_VALUE: 'Price must be greater than 0',
    DAYS_TO_COMPLETE_MIN_VALUE: 'Days To Complete must be greater than 0',
    REPAIR_DESCRIPTION_LENGTH: 'Description must have between 10 and 500 characters',
  },
};
